<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group" [formGroup]="formulario" novalidate>
    <!-- <div class="form-group col-md-9">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div> -->
    <div class="form-group col-12 col-md-4">
      <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
        [comboBox]="listTipoDeReporte" [label]="'Tipo de Reporte *'" formControlName="tipoReporte"
        [control]="formulario.get('tipoReporte')" [id]="'tipoReporte'">
      </app-lfsa-combo-box>
    </div>
    <div class="form-group col-12 col-md-4">
      <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
        [comboBox]="listTiposDeVendedores" formControlName="tipoVendedor" [control]="formulario.get('tipoVendedor')"
        [label]="'Tipo de Vendedor *'" [id]="'tipoVendedor'">
      </app-lfsa-combo-box>
    </div>
    <div class="form-group col-12 col-md-4">
      <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreVendedor1'" [idOpcion]="'idVendedor'"
        [comboBox]="listVendedores" formControlName="vendedorId" [control]="formulario.get('vendedorId')"
        [label]="'Vendedor *'" [id]="'vendedorId'">
      </app-lfsa-combo-box>
    </div>
    <div class="form-group col-12 col-md-2">
      <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Año'" [label]="'Año *'"
        [id]="'anio'" formControlName="anio" [control]="formulario.get('anio')"></app-lfsa-input>
    </div>
    <div class="form-group col-12 col-md-3">
      <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbMeses"
        formControlName="inicioMes" [control]="formulario.get('inicioMes')" [label]="'Desde *'" [id]="'inicioMes'">
      </app-lfsa-combo-box>
    </div>
    <div class="form-group col-12 col-md-3">
      <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbMeses"
        formControlName="finMes" [control]="formulario.get('finMes')" [label]="'Hasta *'" [id]="'finMes'">
      </app-lfsa-combo-box>
    </div>
    <div class="form-group col-md-2" style="display: flex;align-items: center;">
      <button (click)="consultar()" [disabled]="formulario.invalid" class={{DAT_BTNCSS.success}}>Consultar</button>
    </div>
    <div class="form-group col-md-2" style="display: flex;align-items: center;">
      <button (click)="descargarCSV()" [disabled]="rowData.length<=0" class={{DAT_BTNCSS.success}}>Exportar</button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="detalleComosiones" [titulo]="'Detalle de Comisiones'" *ngIf="lsReporteTotal.length > 0">
</app-lfsa-card>

<ng-template #detalleComosiones>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-6"></div>
      <div class="form-group col-12 col-md-2">
        <button class={{DAT_BTNCSS.success}} (click)="descargarCSV()">Reporte</button>
      </div>
      <div class="form-group col-12 col-md-2">
        <button class={{DAT_BTNCSS.success}} (click)="descargarPDF()">Imprimir</button>
      </div>
      <hr class="mt-3 mb-3">
      <div class="form-group col-12" style="overflow: scroll;max-width: 100%;max-height: 500px;">
        <table>
          <tbody>
            <tr *ngFor="let liquidacion of lsReporteTotal">
              <td>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Variable Asignada</th>
                      <th>Sueldo Base</th>
                      <th>Peso %</th>
                      <th>Valor Variable</th>
                      <th>Vendedor</th>
                      <th>% Cumplimiento</th>
                      <th>% Ganancia</th>
                      <th>Comisión</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let vendedor of liquidacion.listVendedoresLiquidacion">
                      <td>{{vendedor.nombreTipoVendedor}}</td>
                      <td>{{vendedor.nombreVariable}}</td>
                      <td align="center">{{vendedor.sueldoExcepcion > 0 ? vendedor.sueldoExcepcion :
                        vendedor.sueldoVariable}}</td>
                      <td align="center">{{vendedor.variablePeso}}</td>
                      <td align="center">{{vendedor.valorPeso}}</td>
                      <td>{{vendedor.nombreVendedor}}</td>
                      <td align="center">{{vendedor.cumplimiento}}</td>
                      <td align="center">{{vendedor.ganancia}}</td>
                      <td align="center">{{vendedor.valorComision}}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <td></td>
                    <td></td>
                    <td align="center">{{liquidacion.sueldoBase}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td align="right" class="totalSticky"><b>TOTAL:</b></td>
                    <td align="center">{{liquidacion.comision}}</td>
                  </tfoot>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>